<template>
  <div v-if="this.display">
<!--    <div class="top-bar">-->
<!--      <i class="fa-solid fa-gift" style="margin-right: 5px;"></i>-->
<!--      <span>-10% sur votre 1er séjour</span>-->
<!--    </div>-->
    <div id="search-banner">
    <div class="container-banner">
      <div class="search-location">
        <a href="javascript:history.go(-1)" class="no-deco mb-5 back-link" onclick="goBack()"> < Retour </a>
        <div class="banner-search">
          <template v-if="lodging">
            <input
              style="border-bottom: 1px solid black !important;"
              class="raleway-reg-p15 search-bar-location"
              type="text"
              :placeholder="$t('Banner.whereto')"
              v-model="search"
            />
          </template>
          <template v-else>
            <input
            style="border-bottom: 1px solid black !important;"
              class="raleway-reg-p15 search-bar-location"
              type="text"
              :placeholder="$t('Banner.whereto')"
              v-model="search"
            />
            <a class="around-btn link-hortense" @click="getLocation">
              <img src="../../images/Localisation.svg" v-set-alt />
              Autour de moi
            </a>
          </template>
          <a
            :href="'/reservation-hotel?search=' + search + '&otherValue=test'"
            :data="search"
            class="no-deco"
          ></a>
        </div>
      </div>
      <div style="border-bottom: 1px solid black !important;" class="search-duration">
        <CommonDatePicker
          :startingDateValue="startDate"
          :endingDateValue="endDate"
          :startDate="minDate"
          :endDate="maxDate"
          ref="datePicker"
          @periodSelected="selectDates"
        />
      </div>
      <div style="border-bottom: 1px solid black !important;" class="search-number">
        <input
          class="raleway-reg-p15 search-bar-top text-center"
          @click="showGuestInfo = !showGuestInfo"
          :placeholder="formatAdults() + ' - ' + formatChilds()"
        />
        <Guestinfo
          v-if="showGuestInfo"
          @ageSelected="updateAges"
          @increaseRooms="updateRooms"
          @decreaseRooms="updateRooms"
          @increaseChilds="updateChilds"
          @decreaseChilds="updateChilds"
          @increaseAdults="updateAdults"
          @decreaseAdults="updateAdults"
          @closed="handleClose"
          :initialAdults="adults"
          :initialChilds="childs"
        />
      </div>

      <template v-if="lodging">
        <button class="hortense-btn-primary" :disabled="disableSearchButton" @click="validate">
          {{ searchButtonCaption }}
        </button>
      </template>
      <template v-else>
        <button class="hortense-btn-primary" :disabled="disableGoButton" >
          <a @click="handleSearchClick" :data="search" class="no-deco text-white">
            <div class="search-button">
              {{ searchButtonCaption }}
            </div>
          </a>
        </button>
      </template>
      <!-- <button class="" @click="close">
        <img src="../../images/Croix fermer.svg" v-set-alt />
      </button> -->
    </div>
  </div>
  </div>
</template>

<script>
import Guestinfo from "components/btns/Guestinfo.vue";
import { VueDatePicker } from "@mathieustan/vue-datepicker";

export default {
  name: "SearchBanner",
  components: { Guestinfo, VueDatePicker },
  props: {
    lodging: {
      type: Object,
      default: null,
    },
    searched: Boolean,
    expandCalendar: Boolean,
  },
  data() {
    return {
      startDate: null,
      endDate: null,
      lat: "",
      long: "",
      not_enable: false,
      valtemp: "",
      selectedDates: [],
      showGuestInfo: false,
      rooms: 1,
      childs: 0,
      adults: 2,
      childAges: [],
      color: "#CDDFD3",
      date: new Date(),
      currentDate: new Date(),
      display: true,
      isSearching: false,
    };
  },
  watch: {
    searched() {
      this.isSearching = !this.searched;
    },
    expandCalendar(new_value, old_value) {
      if (this.expandCalendar) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.$refs.datePicker.showDatepicker();
        }, 100);
      }
      this.$emit('updateExpandCalendar')
    },
  },
  methods: {
    goBack() {
    window.history.back();
    this.popstateHandler = () => {
      window.scrollTo(0, 0);
    };
    setTimeout(() => {
        window.addEventListener('popstate', this.popstateHandler);
    }, 100);
  },
    handleClose() {
      this.showGuestInfo = false;
    },
    formatDateKoedia(date) {
      if (!date) return null;
        if (date.includes('-')) {
          return date;
        }
        const dateBits = date.split('/');
        return `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}`; 
      },
    formatDateSyntax(dateString) {
      let dateParts = dateString.split('/');

      let day = dateParts[0];
      let month = dateParts[1];
      let year = dateParts[2].slice(-2);

      return `${day}/${month}/${year}`;
    },
    handleSearchClick() {
      window.dataLayer = window.dataLayer || [];
      let bookingWindow = null;

      if (this.selectedDates && this.selectedDates[0]) {
        const dateInParts = this.selectedDates[0].split('/');
        const dateIn = new Date(`${dateInParts[2]}-${dateInParts[1]}-${dateInParts[0]}`);
        const today = new Date();
        const timeDifference = dateIn - today;
        bookingWindow = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      }
      const dateIn = this.selectedDates ? this.selectedDates[0] : null;
      const dateOut = this.selectedDates ? this.selectedDates[1] : null;

      const numberOfNights = (dateIn && dateOut)
        ? Math.ceil((new Date(dateOut) - new Date(dateIn)) / (1000 * 60 * 60 * 24))
        : null;

      window.dataLayer.push({
        event: 'search',
        ecommerce: {
          search_term: this.search,
          booking_window: bookingWindow,
          date_in: this.selectedDates ? this.formatDateSyntax(this.selectedDates[0]) : null,
          date_out: this.selectedDates ? this.formatDateSyntax(this.selectedDates[1]) : null,
          number_of_people: parseInt(this.adults || 2) + parseInt(this.childs || 0),
          number_of_adult: this.adults,
          number_of_child: this.childs,
          results: 144,
          number_of_nights: numberOfNights
        }
      });
      const url = `/reservation-hotel?via=banner&search=${this.search}&childs=${this.childs}&adults=${this.adults}`;
      window.location.href = url;  // Redirect to the constructed URL
    },
    setInitialDatesFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const from = urlParams.get('from');
      const to = urlParams.get('to');

      if (from && to) {
        this.selectedDates = [this.formatDate(from), this.formatDate(to)];
      }
    },
    validate() {
      window.dataLayer = window.dataLayer || [];
      let bookingWindow = null;

      if (this.selectedDates && this.selectedDates[0]) {
        const dateInParts = this.selectedDates[0].split('/');
        const dateIn = new Date(`${dateInParts[2]}-${dateInParts[1]}-${dateInParts[0]}`);
        const today = new Date();
        const timeDifference = dateIn - today;
        bookingWindow = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      }

      const dateIn = this.selectedDates ? this.selectedDates[0] : null;
      const dateOut = this.selectedDates ? this.selectedDates[1] : null;

      const numberOfNights = (dateIn && dateOut)
        ? Math.ceil((new Date(dateOut) - new Date(dateIn)) / (1000 * 60 * 60 * 24))
        : null;

      window.dataLayer.push({
        event: 'search',
        ecommerce: {
          search_term: this.search,
          booking_window: bookingWindow, // Will be null if selectedDates is not defined
          date_in: this.selectedDates ? this.formatDateSyntax(this.selectedDates[0]) : null,
          date_out: this.selectedDates ? this.formatDateSyntax(this.selectedDates[1]) : null,
          number_of_people: parseInt(this.adults || 2) + parseInt(this.childs || 0),
          number_of_adult: this.adults,
          number_of_child: this.childs,
          results: 144,
          number_of_nights: numberOfNights
        }
      });
      this.$emit("selectDates", this.selectedDates);
      this.$emit("adultsNum", this.adults);
      this.$emit("childsNum", this.childs);
      this.$emit("childsAge", this.childAges);
      this.$emit("formSubmit");
      this.isSearching = true;
      this.showGuestInfo = false;
    },
    formatKoediaDate(date) {
      if(date) {
        if (date.includes('-')) {
          return date;
        }
        const dateBits = date.split('/');
        return `${dateBits[2]}-${dateBits[1]}-${dateBits[0]}`; 
      } else {
        return null
      }
    },
    selectDates(event, start, end) {
      this.selectedDates = [this.formatDate(start), this.formatDate(end)];

      const state = {
        adults: this.adults,
        childs: this.childs,
        children_ages: Array.isArray(this.childAges) ? [...this.childAges] : [],
      };

      if (this.selectedDates && this.selectedDates.length === 2 && this.selectedDates[0] && this.selectedDates[1]) {
        state.koediaFrom = this.formatKoediaDate(this.selectedDates[0]);
        state.koediaTo = this.formatKoediaDate(this.selectedDates[1]);
        state.from = this.formatKoediaDate(this.selectedDates[0]);
        state.to = this.formatKoediaDate(this.selectedDates[1]);
      }

      localStorage.setItem('reservationState', JSON.stringify(state));
    },
    formatDate(date) {
      if (!date) return null;
      const set = new Date(date);
      const options = { year: "numeric", month: "numeric", day: "numeric" };
      //return set.toLocaleString("default", options);
      return set.toLocaleString("fr", options);
    },
    getLocation() {
      navigator.geolocation.getCurrentPosition(function (position) {
        let lat = position.coords.latitude;
        let long = position.coords.longitude;
        window.open(`/reservation-hotel?geo=${lat},${long}`, '_blank');
        // Turbolinks.visit(`/reservation-hotel?geo=${lat},${long}`);
      });
    },
    updateRooms(room) {
      this.rooms = room;
      this.$emit("numberOfRoom", this.rooms);
    },
    formatRooms() {
      let chambre = " Chambre";
      if (this.rooms > 1) {
        chambre += "s";
      }
      return this.rooms + chambre;
    },
    updateChilds(child) {
      this.childs = child;
      this.$emit("numberOfChild", this.childs);
      this.setreservationStateCacheForAdultsAndChilds();
    },
    formatChilds() {
      let enfant = " Enfant";
      if (this.childs > 1) {
        enfant += "s";
      }
      return this.childs + enfant;
    },
    updateAdults(adult) {
      this.adults = adult;
      this.$emit("numberOfAdult", this.adults);
      this.setreservationStateCacheForAdultsAndChilds();
    },
    setreservationStateCacheForAdultsAndChilds() {
      const state = JSON.parse(localStorage.getItem('reservationState')) || {};
      state.adults = this.adults;
      state.childs = this.childs;
      localStorage.setItem('reservationState', JSON.stringify(state));
    },
    updateAges(value) {
      this.childAges = [...value];
      this.$emit("ageOfChild", this.childAges);
    },
    formatAdults() {
      let adulte = " Adulte";
      if (this.adults > 1) {
        adulte += "s";
      }
      return this.adults + adulte;
    },
    close() {
      if (this.lodging) {
        this.display = false;
      } else {
        this.$emit("close");
      }
    },
    loadState() {
      const state = JSON.parse(localStorage.getItem('reservationState'));
      if (state) {
        // this.from = state.from;
        // this.to = state.to;
        // this.koediaFrom = state.koediaFrom;
        // this.koediaTo = state.koediaTo;
        // this.adults = state.adults;
        // this.childs = state.childs;
        // this.childDate = state.childDate;
        // this.roomChoosed = state.roomChoosed;
        // this.totalTtc = state.totalTtc;
        // this.pricePerNightHt = state.pricePerNightHt;
        // this.selectedOption = state.selectedOption;
        // this.isChoosing = state.isChoosing;
        if (state.adults !== undefined && state.adults !== null) {
          this.adults = parseInt(state.adults, 10);
        }
        if (state.childs !== undefined && state.childs !== null) {
          this.childs = parseInt(state.childs, 10);
        }
        if (Array.isArray(state.children_ages)) {
          this.childAges = [...state.children_ages];
        }
        if (state.from && state.to) {
          this.startDate = new Date(this.formatDateKoedia(state.from));
          this.endDate = new Date(this.formatDateKoedia(state.to));
          // let initialFromDate = new Date(state.from);
          // let initialToDate = new Date(state.to);
          // this.selectedDates = [initialFromDate, initialToDate];
        }
      }
    },
  },
  computed: {
    searchButtonCaption() {
      return this.isSearching ? "Recherche en cours..." : "Valider";
    },
    disableSearchButton() {
      return this.isSearching;
    },
    disableGoButton(){
      return this.getlocate;
    },
    minDate() {
      return new Date(
        this.currentDate.getFullYear(),
        this.currentDate.getMonth(),
        this.currentDate.getDate()
      );
    },
    maxDate() {
      return new Date(
        this.currentDate.getFullYear() + 1,
        this.currentDate.getMonth(),
        this.currentDate.getDate()
      );
    },
    search: {
      get () {
        if (this.lodging) {
          return this.lodging.name
        }
        else{
          return this.valtemp;
        }
      },
      set (newValue) {
        this.valtemp = newValue
      }
    },
  },
  created() {
    this.setInitialDatesFromUrl();
    const urlParams = new URLSearchParams(window.location.search);
    const from = urlParams.get('from');
    if(from) {
      this.$emit("selectDates", this.selectedDates);
      this.$emit("adultsNum", this.adults);
      this.$emit("childsNum", this.childs);
      this.$emit("childsAge", this.childAges);
      this.$emit("formSubmit");
      this.isSearching = true;
      this.showGuestInfo = false;
    }
  },
  mounted() {
    this.loadState();
  },
  beforeDestroy() {
    if (this.popstateHandler) {
      window.removeEventListener('popstate', this.popstateHandler);
    }
  },
};
</script>
<style>
.vhd__datepicker__clear-button svg {
  display: none !important;
}
.top-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  font-size: 15px;
  color: white;
  background: #1c1c1c;
  position: sticky;
  top: 0;
  z-index: 1;
}
.vhd__datepicker__input:first-child {
  background: white !important;
  border-bottom: none;
}

.vhd__datepicker__dummy-wrapper {
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-bottom:none !important;
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}

@media only screen and (max-device-width: 480px) {
  .vhd__datepicker__dummy-wrapper {
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-bottom:none !important;
  cursor: pointer;
  display: flex;
  flex-wrap: nowrap !important;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}
}

.vhd__datepicker__month-button,
.vhd__datepicker__month-button--prev {
  /*.vhd__datepicker__month-button {*/
  background: transparent url(/packs/media/img/ic-arrow-right-green.regular.83ed3b6c-93e0ea4a.svg)
    no-repeat 50%/8px;
  width: 2.5em;
  height: 2.5em;
  border: 1px solid #cddfd3 !important;
  outline: none;
  text-align: center;
  cursor: pointer;
  opacity: 1;
  transition: opacity 0.5s ease;
}

@media screen and (min-width: 768px) {
  .vhd__datepicker__month-day-wrapper {
    &:hover {
      background-color: #3B6152 !important;
      cursor: pointer;
    }
  } 
}

.vhd__datepicker__month-day--today {
  .vhd__datepicker__month-day-wrapper {
    border: 2px solid #3B6152 !important;
  }
}

.vhd__datepicker__month-day--first-day-selected.vhd__datepicker__month-day--today > .vhd__datepicker__month-day-wrapper {
  border: unset !important;
}

.vhd__datepicker__month-day--first-day-selected.vhd__datepicker__month-day--today .vhd__datepicker__month-day-wrapper {
  padding-top: calc(100% - 1px) !important;
}

.vhd__datepicker__month-day--first-day-selected {
  border-radius: 10px 0px 0px 10px !important;
}

.vhd__datepicker__month-day--last-day-selected {
  border-radius: 0px 10px 10px 0px !important;
}

.vhd__datepicker__month-day--first-day-selected,
.vhd__datepicker__month-day--last-day-selected {
  background: #3B6152 !important;
  color: #fff;
  cursor: pointer;
  font-weight: 700;
  pointer-events: auto;
}
.vhd__datepicker__month-day--selected {
  background-color: #A5D3AE !important;
  color: #fff;
}
.back-link {
  display: none;
}

@media only screen and (max-width: 700px) {
  .back-link {
    display: block;
  }
}

</style>
